module.exports = __webpack_public_path__ + "static/media/jeel-radio.d3c7d4dc.png";